'use client'

import Script from "next/script"

export default function Analytics() {
  return (
    <Script async defer src="https://scripts.withcabin.com/hello.js" />
  )
}